import { useEffect, useMemo, useState } from "react";
import { ApiCourseRequest } from "data/queries/ApiCourse";

const EDUCATIONAL_UNITS_QUERY = `
  query EventEducationalUnits {
    EducationalUnits(perPage: -1, active: null) {
      items {
        id
        visibleName
        active
        city
        state
      }
    }
  }
`;

export interface EventEducationalUnit {
  id: number;
  visibleName: string;
  active: boolean;
  city: string;
  state: string;
}

interface EducationalUnitsGql {
  EducationalUnits: {
    items: EventEducationalUnit[];
  };
}

export default function useEducationalUnits() {
  const [units, setUnits] = useState<EventEducationalUnit[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let ignore = false;

    setLoading(true);
    ApiCourseRequest<EducationalUnitsGql>({ query: EDUCATIONAL_UNITS_QUERY })
      .then((response) => {
        if (ignore) return;
        setUnits(response.data.data?.EducationalUnits.items || []);
      })
      .catch(() => {
        if (!ignore) setUnits([]);
      })
      .finally(() => {
        if (!ignore) setLoading(false);
      });

    return () => {
      ignore = true;
    };
  }, []);

  const unitsById = useMemo(() => {
    return units.reduce<Record<number, EventEducationalUnit>>((acc, unit) => {
      acc[unit.id] = unit;
      return acc;
    }, {});
  }, [units]);

  return { units, unitsById, loading };
}
